import type { FaireProductEntity } from "../../entity_types/product";

export const p_jsch2gcvju: FaireProductEntity = {
  token: "p_jsch2gcvju",
  type: "product",
  name: "Hawaiian Flora - Folded Cards Set of 6",
  brandName: "Misha Hawaii Home",
  imageUrl:
    "https://cdn.faire.com/fastly/bb653f6f08a5ea656dfcf74a92d067a7914d7c528dc2ac389710ce60c958a545.jpeg",
  priceDollars: 12.5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/0efd8d14c6e70e35b3b74a6f586e973c92e860ee35a42470daec0ac1ad25ea00.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
